import createStore from "../utils/create-store";

interface IOQueryParamStore {
    isNBNudgeEnabled: boolean;
    setNBNudgeEnabled: (data: boolean) => void;
    isCommunityOnboardingEnabled: boolean;
    setIsCommunityOnboardingEnabled: (data: boolean) => void;
}

export const useWebQueryParamStore = createStore<IOQueryParamStore>((set) => ({
    isNBNudgeEnabled: false,
    isCommunityOnboardingEnabled: false,
    setNBNudgeEnabled: (data) =>
        set((state) => {
            state.isNBNudgeEnabled = data;
        }),
    setIsCommunityOnboardingEnabled: (data) =>
        set((state) => {
            state.isCommunityOnboardingEnabled = data;
        }),
}));